import {
  fetchData,
  rateLimitedLoop,
  fetchFromShopify,
  fetchWithCache,
} from "./util.js";

const targetedElements = document.querySelectorAll('[id^="expanded-"]');
const bodyTargetNode = document.body;
const navBarSearchButton = document.querySelector(".js-search-mobile");
const showMoreResourcesButton = document.querySelector(
  ".show-more-resources-button",
);

function isDesktop() {
  return window.innerWidth > 1024;
}

Object.assign(window.Shopify, {
  addSizeToImage: function addSizeToImage(src, width, height) {
    const url = new URL(
      src,
      window.location.protocol + "//" + window.Shopify.cdnHost,
    );

    width && url.searchParams.append("width", width);
    height && url.searchParams.append("height", height);

    return url.toString();
  },
  getHandle: function getHandle(str) {
    const [match] = str.match(/(?!(.*\/))(.*?)(?=\#|\?|\.|$)/gm);
    return match;
  },
  handleize: function handleize(str) {
    return str
      .toLowerCase()
      .replace(/[^\w\u00C0-\u024f]+/g, "-")
      .replace(/^-+|-+$/g, "");
  },
  formatPrice: function formatPrice(value, currency = false) {
    const amount = Number(value) / 100; // Convert cents to dollars
    return currency
      ? new Intl.NumberFormat("en-US", { style: "currency", currency }).format(
          amount,
        )
      : amount.toFixed(2); // Ensure two decimal places
  },
});

// lock body when search is active
if (isDesktop()) {
  const callback = function (mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        const aaPanelElement = document.querySelector(".aa-Panel");
        if (aaPanelElement) {
          document.documentElement.classList.add("lock-all");
        } else {
          document.documentElement.classList.remove("lock-all");
        }
      }
    }
  };

  // Options for the observer (which mutations to observe)
  const config = { childList: true, subtree: true };

  // Create an observer instance linked to the callback function
  const Desktopobserver = new MutationObserver(callback);

  // Assuming bodyTargetNode is already defined somewhere in your script
  Desktopobserver.observe(bodyTargetNode, config);
}

// adds a pop to each selector and copies the inner to clip board
function updateSKUSelectors() {
  const toolTips = document.querySelectorAll(".tooltip");
  toolTips.forEach((toolTip) => {
    toolTip.addEventListener("click", function () {
      // Create and append input for copying the text content
      const inp = document.createElement("input");
      document.body.appendChild(inp);
      const valueToCopy = this.textContent.includes(":")
        ? this.textContent.split(":")[1].trim()
        : this.textContent.trim();
      inp.value = valueToCopy;
      inp.select();
      document.execCommand("copy", false);
      inp.remove();

      // Create the copied popover
      const coppied = document.createElement("span");
      coppied.setAttribute("class", "tooltip-item");
      coppied.innerHTML = "Copied!";
      this.parentNode.insertBefore(coppied, this.nextSibling);

      // Create and manage the popover with Popper
      let inst = Popper.createPopper(this, coppied, {
        placement: "top",
      });

      // Remove the popover after 1 second
      setTimeout(() => {
        if (inst && typeof inst.destroy === "function") {
          inst.destroy();
          inst = null;
        }

        if (coppied && coppied.parentNode) {
          coppied.remove();
        }
      }, 1000);
    });
  });
}

function loadBrandImages() {
  const searchParams = new URLSearchParams(window.location.search);

  const hasBrand2 = searchParams.has("filter.p.m.custom.collection_brand_2");

  if (!hasBrand2) {
    return;
  }

  if (isDesktop()) {
    // Desktop version
    const desktopTarget = document.getElementById(
      "filter-p-m-custom-collection_brand_2",
    );
    if (desktopTarget) {
      const imagesToLoad = desktopTarget.querySelectorAll(".custom-load");
      imagesToLoad.forEach((x) => x.classList.add("lazyload"));
    }
  } else {
    // Mobile version
    const mobileTarget = document.getElementById(
      "mobile-filter-p-m-custom-collection_brand_2",
    );
    if (mobileTarget) {
      const imagesToLoad = mobileTarget.querySelectorAll(".mobile-custom-load");
      imagesToLoad.forEach((x) => x.classList.add("lazyload"));
    }
  }
}

// filter
function handleCollectionFilterClose(event) {
  // matching for custom filter
  const regex = /[?&]filter\.p\.m\.custom\.[^&]+=([^&]+)/g;
  const matches = window.location.search.match(regex);
  if (!matches) {
    return; // Handle case where no matches are found
  }

  matches.forEach((match) => {
    const rawFilter = decodeURIComponent(match);
    const find = rawFilter.replace(/[&?]/g, "").split("=")[0];
    const found = document.querySelector(`div[data-parent^="${find}"]`);
    if (found) {
      const parentElement = found.parentElement.parentElement.parentElement;
      parentElement.style.backgroundColor = "var(--header-accent-color)";
      parentElement.style.color = "white";
    }
  });
}

function updateChatButtonPositions(isOpening) {
  const chatButton = document
    .getElementById("gorgias-chat-container")
    .querySelector("#chat-button");
  chatButton.parentElement.style.display = isOpening ? "block" : "none";
}

function initQuantityPickers(root = document) {
  if (!isDesktop()) return;

  root.querySelectorAll(".quantity-selector").forEach((el) => {
    if (
      el.closest('[data-section-type="product"]') ||
      el.dataset.quantityPickerInit
    ) {
      return;
    }

    new QuantityPicker(el);
    el.dataset.quantityPickerInit = "true";
  });
}

function watchRecentlyViewedProducts() {
  document
    .querySelectorAll('[data-section-type="recently-viewed-products"]')
    .forEach((section) => {
      const placeholder = section.querySelector(
        ".recently-viewed-products-placeholder",
      );
      if (!placeholder) return;

      const observer = new MutationObserver(() => {
        initQuantityPickers(placeholder);
      });

      observer.observe(placeholder, { childList: true, subtree: true });
    });
}

window.addEventListener("DOMContentLoaded", async (event) => {
  initQuantityPickers();
  watchRecentlyViewedProducts();

  // read more custom
  targetedElements.forEach((element) => {
    element.addEventListener("change", function () {
      var labelSpan = this.parentElement.querySelector(".readmore");

      if (this.checked) {
        labelSpan.previousElementSibling.style.maxHeight = "unset";
        labelSpan.textContent = "Read Less...";
      } else {
        labelSpan.previousElementSibling.style.maxHeight = "initial";
        labelSpan.textContent = "Read More...";
      }
    });
  });

  navBarSearchButton &&
    navBarSearchButton.addEventListener("click", function () {
      const skipSearchOpenButton = document.querySelector(
        ".aa-DetachedSearchButton",
      );
      if (skipSearchOpenButton) {
        skipSearchOpenButton.click();
        document.dispatchEvent(
          new CustomEvent("gorgias", {
            detail: {
              open: false,
            },
          }),
        );
      }
    });

  showMoreResourcesButton &&
    showMoreResourcesButton.addEventListener("click", function () {
      const showMoreResources = document.querySelectorAll(
        ".show-more-resources",
      );

      // Check if resources are currently hidden
      const isExpanded = showMoreResources[0]?.style.display === "block";

      if (isExpanded) {
        // Collapse - hide resources and change button text
        showMoreResourcesButton.textContent = "Show More";
        showMoreResources.forEach((resource) => {
          resource.style.display = "none";
        });
      } else {
        // Expand - show resources and change button text
        showMoreResourcesButton.textContent = "Show Less";
        showMoreResources.forEach((resource) => {
          resource.style.display = "block";
        });
      }
    });

  updateSKUSelectors();

  // brand lazyload on click
  document.querySelectorAll(".collection__filter-group-name").forEach((el) => {
    el.addEventListener("click", (e) => {
      if (
        e.target.getAttribute("aria-controls") ===
        "filter-p-m-custom-collection_brand_2"
      ) {
        const desktopTarget = document.getElementById(
          "filter-p-m-custom-collection_brand_2",
        );
        const imagesToLoad = desktopTarget.querySelectorAll(".custom-load");
        imagesToLoad.forEach((x) => x.classList.add("lazyload"));
      } else if (
        e.target.getAttribute("aria-controls") ===
        "mobile-filter-p-m-custom-collection_brand_2"
      ) {
        const mobileTarget = document.getElementById(
          "mobile-filter-p-m-custom-collection_brand_2",
        );
        const imagesToLoad = mobileTarget.querySelectorAll(
          ".mobile-custom-load",
        );

        imagesToLoad.forEach((x) => x.classList.add("lazyload"));
      }
    });
  });

  document.addEventListener("gorgias", (e) =>
    updateChatButtonPositions(e.detail.open),
  );

  await getProductStatus();

  if (!isDesktop()) {
    initScrollableProductList();
  }

  if (window.location.pathname.includes("/products/")) {
    const key = "TKG-shopifyBreadcrumbData";
    const sizeInKB =
      new TextEncoder().encode(localStorage.getItem(key) || "").length / 1024;
    console.log(`${key} size: ${sizeInKB.toFixed(2)} KB`);

    const container = document.querySelector(
      ".product-gallery__thumbnail-list",
    );

    if (container) {
      container.addEventListener("scroll", () => {
        if (container.scrollTop > 130) {
          loadRemainingImages();
        }
      });

      container.addEventListener("touchmove", (e) => {
        const scrollTop = container.parentElement;
        if (scrollTop.scrollLeft > 140) {
          loadRemainingImages();
        }
      });
    }

    // zoom in thingy
    const productGallery = document.querySelector(".product-gallery__carousel");

    if (productGallery && isDesktop()) {
      productGallery.addEventListener("mouseenter", () => {
        const $selectedImage = document.querySelector(
          ".product-gallery__carousel-item.is-selected .product-gallery__image",
        );

        if ($selectedImage) {
          // Ensure jQuery is loaded
          if (window.jQuery && typeof $.fn.elevateZoom !== "undefined") {
            if (document.querySelector(".zoomContainer")) {
              return;
            }

            // Apply elevateZoom
            $($selectedImage).elevateZoom({
              zoomType: "window",
              cursor: "pointer",
              scrollZoom: true,
              responsive: false,
              zoomLevel: 1,
              lensOpacity: 0.2,
              lensBorderSize: 0,
              zoomWindowWidth: 400, // Zoom window width
              zoomWindowHeight: 400,
            });
          } else {
            console.log("jQuery is not loaded yet.");
          }
        }
      });
    }
  }
});

function loadRemainingImages() {
  // Find all lazy images that haven't been loaded yet (the ones after the first 5)
  const lazyImages = document.querySelectorAll(
    ".product-gallery__thumbnail img.slider-lazy",
  );

  // Loop through the images and check if they are near the bottom
  lazyImages.forEach((img) => {
    const rect = img.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight && rect.bottom >= 0; // Check if image is visible in the viewport

    if (isVisible) {
      // Replace the placeholder src with the actual image source
      img.src = img.getAttribute("data-src");
      img.srcset = img.getAttribute("data-srcset");
      img.classList.remove("slider-lazy"); // Remove lazy loading class to indicate it's loaded
    }
  });
}

async function getProductStatus() {
  return fetchWithCache(
    `{
          metaobjects(first: 50, type: "product_satus") {
              edges {
                  node {    
                      id
                      Title: field(key: "title") {
                          value
                      }
                      Disabled: field(key: "disabled") {
                          value
                      }
                      ButtonColour: field(key: "button_colour") {
                        value
                      }
                      TextColour: field(key: "text_colour") {
                        value
                      }
                      Badge: field(key: "badge") {
                          reference {
                              ... on Metaobject {
                                  field(key: "title") {
                                      value
                                  }
                              }
                          }
                      }
                  }
              }
          }
      }`,
    "TKG-product_status",
    false,
  );
}

// we have to listin for when filter change as it updates all html
document.addEventListener("theme:loading:end", function (event) {
  updateSKUSelectors();
  handleCollectionFilterClose();
  loadBrandImages();
  initQuantityPickers();
  watchRecentlyViewedProducts();
});

// overflow scroll is not available on ios and firefox so we need to use this mess
const initScrollableProductList = () => {
  const container = document.querySelector(".product-list--scrollable");
  if (!container) return; // Exit if container not found

  const elements = [...document.querySelectorAll(".product-item--vertical")];
  if (!elements.length) return; // Exit if no product items found

  let activeIndex = 0;

  // Handle intersection observer callbacks
  const handleIntersect = (entries) => {
    const entry = entries.find((e) => e.isIntersecting);
    if (entry) {
      activeIndex = elements.findIndex((e) => e === entry.target);
    }
  };

  // Initialize intersection observer
  const observer = new IntersectionObserver(handleIntersect, {
    root: container,
    rootMargin: "0px",
    threshold: 0.75,
  });

  // Observe all product elements
  elements.forEach((el) => observer.observe(el));

  // Add click event listeners to navigation buttons
  const prevButton = document.querySelector(".prev-product-button");
  const nextButton = document.querySelector(".next-product-button");

  if (prevButton) {
    prevButton.addEventListener("click", () => {
      if (activeIndex > 0) {
        elements[activeIndex - 1].scrollIntoView({
          behavior: "smooth",
          inline: "start",
          block: "nearest",
        });
        activeIndex--;
      }
    });
  }

  if (nextButton) {
    nextButton.addEventListener("click", () => {
      if (activeIndex < elements.length - 1) {
        elements[activeIndex + 1].scrollIntoView({
          behavior: "smooth",
          inline: "start",
          block: "nearest",
        });
        activeIndex++;
      }
    });
  }
};

const observer = new IntersectionObserver(
  (entries, obs) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        let scriptSrc = entry.target.dataset.src;

        // Handle single string or array
        try {
          scriptSrc = JSON.parse(scriptSrc); // if it's a JSON array
        } catch {
          scriptSrc = [scriptSrc]; // fallback to single string
        }

        const scriptsToLoad = scriptSrc.filter(
          (src) => !isScriptFullyLoaded(src),
        );

        if (scriptsToLoad.length === 0) {
          obs.unobserve(entry.target);
          return;
        }

        let loadedCount = 0;

        scriptsToLoad.forEach((src) => {
          window.loadScript(
            src,
            () => {
              loadedCount++;
              if (loadedCount === scriptsToLoad.length) {
                document.dispatchEvent(new CustomEvent("load_search"));
              }
            },
            () => {
              console.error("Failed to load script:", src);
            },
          );
        });

        obs.unobserve(entry.target);
      }
    });
  },
  { threshold: 0 },
);

// Attach observer to elements you want to track
// document
//   .querySelectorAll("#react-target")
//   .forEach((el) => observer.observe(el));

window.scriptLoadMap = {};

function markScriptFullyLoaded(src) {
  window.scriptLoadMap[src] = true;
}

function isScriptAdded(src) {
  return Boolean(document.querySelector(`script[src="${src}"]`));
}

function isScriptFullyLoaded(src) {
  return window.scriptLoadMap[src] || false;
}

function loadScript(src, onLoadCallback, onLoadErrorCallback) {
  if (!src) return;

  if (isScriptAdded(src)) {
    if (isScriptFullyLoaded(src) && onLoadCallback) onLoadCallback();
    console.warn("Script already added. Skipping:", src);
    return;
  }

  const script = document.createElement("script");
  script.src = src;
  script.async = true;

  script.onload = () => {
    markScriptFullyLoaded(src);
    if (onLoadCallback) onLoadCallback();
  };

  script.onerror = () => {
    console.error("Failed to load:", src);
    script.remove();
    if (onLoadErrorCallback) onLoadErrorCallback();
  };

  document.head.appendChild(script);
}

window.loadScript = loadScript;
